import { Store, StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import InstagramTaggedProductEntity from "../entities/InstagramTaggedProductEntity";

export interface TaggedProductState {
    product: null | InstagramTaggedProductEntity;
}

const createInitialState = (): TaggedProductState => ({
    product: null,
});

@singleton()
@StoreConfig({ name: "tagged-product", idKey: "id" })
class InstagramTaggedProductStore extends Store<TaggedProductState> {
    constructor() {
        super(createInitialState());
    }
}

export default InstagramTaggedProductStore;
